import cookie from '../../common/cookie';
import { loginCookie } from '../login/common';
var qqAppid = '101484782';
var wxAppid = 'wxa09391bb0085f4b0';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'tgclub'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve) {
    if (typeof Tgclub !== 'undefined') {
      resolve(Tgclub);
      return;
    }

    document.addEventListener('TgclubReady', function () {
      resolve(Tgclub);
    }, false);
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.showLogin();
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loginByQQAndWX();
};

var loginByQQ = function loginByQQ() {
  loginByQQAndWX();
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve) {
    var logintype = cookie.get('acctype');
    var mobileqopenid = cookie.get('openid');
    var mobileqtoken = cookie.get('access_token');
    var wopenid = cookie.get('openid');
    var waccesstoken = cookie.get('access_token');

    if (logintype === 'qc' && mobileqopenid && mobileqtoken) {
      window.iUseQQConnect = 1;
      loginCookie.setLocal({
        acctype: 'qc',
        appid: qqAppid,
        openid: mobileqopenid,
        access_token: mobileqtoken
      }, 7200);
    } else if (logintype === 'wx' && wopenid && waccesstoken) {
      loginCookie.setQQ({
        acctype: 'wx',
        appid: wxAppid,
        openid: wopenid,
        access_token: waccesstoken
      }, 7200);
    }

    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var currentAcctype = cookie.get('acctype');

    if (currentAcctype === 'wx') {
      resolve('wx');
    } else if (currentAcctype === 'qc') {
      resolve('qc');
    } else {
      resolve(null);
    }
  });
};

var logout = function logout() {
  loginCookie.clearLocal();
  loginCookie.clearQQ();
};

var tgclub = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default tgclub;